import {Subject} from "rxjs";
import {SegmentEventTypes} from "./SegmentEventTypes";
import Segment from "../../../models/view/lessonPage/Segment";
import Note from "../../../models/soundslice/Note";
import {logger} from "../../log/logger";
const segmentSubject = new Subject<SegmentEventTypes>();

/**
 * Subscribe to events related to segment.
 * Returns unsubscribe function
 * @param callback - function to be executed whenever an event is emitted via call to Subject next()
 */
export function subscribeToSegmentEvents(callback: (message: SegmentEventTypes) => void){
  const protectedCallback = (message: SegmentEventTypes) => {
    try{
      callback(message);
    }catch(e){
      logger.lesson.error({message: `error encountered in observer of SegmentEventTypes `, error: e as Error});
    }
  };
  const subscription = segmentSubject.subscribe(protectedCallback);
  return subscription.unsubscribe.bind(subscription);
}

function emitSegmentMessage(message: SegmentEventTypes){
  return segmentSubject.next(message);
}

export function segmentChanged(segment?: Segment){
  return emitSegmentMessage({type: "segmentChanged", segment});
}

export function segmentNotesChanged(notes?: Note[]){
  return emitSegmentMessage({type:"segmentNotesChanged", notes});
}

export function lessonLoaded() {
  return emitSegmentMessage({type: "lessonLoaded"});
}